<template>
  <div class="summary-wrapper" :class="{TA:isTestAchat}">
    <h1>{{ $t('informations.title', [simulation ? $t('informations.simulation') : $t('informations.comparison')]) }}</h1>



    <div class="summary inline top" :class="$mq">
      <div class="list" v-if="hasElec" :style="{'--grid-area': gasMeter ? 'elec' : 'auto'}">
        <h3 class="list__title">
          <img class="list__title__icon" src="@/assets/icons/icon-elec.svg"/> 
          <span class="list__title__value">{{ $t("Offer.summary.elec") }}</span>
        </h3>
        <ul class="list__items">
          <li class="list__items__item list__items__item--group-title" v-if="monoMeter">
            <span class="list__items__item__label ">{{ getMeterTypeLabel('mono') }}</span>
            <span class="list__items__item__value">{{ monoMeter.value }} kWh</span>
          </li>
          <li class="list__items__item list__items__item--group-title" v-if="touMeter">
            <span class="list__items__item__label">{{ getMeterTypeLabel('bi') }}</span>
          </li>
          <li class="list__items__item" v-if="touMeter">
            <span class="list__items__item__label">{{ getMeterTypeLabel('day') }}</span>
            <span class="list__items__item__value">{{ touMeter.day }} kWh</span>
          </li>
          <li class="list__items__item" v-if="touMeter">
            <span class="list__items__item__label">{{ getMeterTypeLabel('night') }}</span>
            <span class="list__items__item__value">{{ touMeter.night }} kWh</span>
          </li>
          <li class="list__items__item list__items__item--group-title" v-if="nightMeter">
            <span class="list__items__item__label">{{ getMeterTypeLabel('exclusiveNight') }}</span>
            <span class="list__items__item__value">{{ nightMeter.value }} kWh</span>
          </li>
              <li class="list__items__item list__items__item--group-title" v-if="injectionBaseMeter">
            <span class="list__items__item__label">{{ getMeterTypeLabel('injectionBase') }}</span>
            <span class="list__items__item__value">{{ injectionBaseMeter.value
               }} kWh</span>
          </li>                
          <li class="list__items__item list__items__item--group-title" v-if="hasSolarPanels">
            <span class="list__items__item__label">{{ getMeterTypeLabel('solarPanel') }}</span>
            <span class="list__items__item__value">{{ solarPanelsPower }} {{ $t("Offer.summary.meter.solarPanelUnit") }}</span>
          </li>
          <li class="list__items__item list__items__item--group-title" v-if="injectionTouMeter">
            <span class="list__items__item__label">{{ getMeterTypeLabel('injection') }}</span>
          </li>
          <li class="list__items__item" v-if="injectionTouMeter">
            <span class="list__items__item__label">{{ getMeterTypeLabel('injectionDay') }}</span>
            <span class="list__items__item__value">{{ injectionTouMeter.injectionDay }} kWh</span>
          </li>
          <li class="list__items__item" v-if="injectionTouMeter">
            <span class="list__items__item__label">{{ getMeterTypeLabel('injectionNight') }}</span>
            <span class="list__items__item__value">{{ injectionTouMeter.injectionNight }} kWh</span>
          </li>
          <li class="list__items__item list__items__item--group-title" v-if="hasSmartMeter">
            <span class="list__items__item__label">{{ $t("Offer.summary.smartMeter.smartMeter") }}</span>
          </li>
          <li class="list__items__item" v-if="hasSmartMeter">
            <span class="list__items__item__label">{{ $t("Offer.summary.smartMeter.quarterRegime") }}</span>
            <span class="list__items__item__value">{{ $t(`Offer.Carousel.Help.${hasQuarterRegime ? "yes" : "no"}`) }}</span>
          </li>
          <li class="list__items__item" v-if="hasSmartMeter">
            <span class="list__items__item__label">{{ $t("Offer.summary.smartMeter.peakLevel") }}</span>
            <span class="list__items__item__value"> {{ roundedPeakLevel }} kW</span>                  
          </li>
          <li class="list__items__item list__items__item--group-title" v-if="hasSmartMeter && !knowPeakLevel">
            <span class="list__items__item__label"> 
              <small>
              {{ $t(`Offer.summary.smartMeter.doNotKnowPeakLevel`) }}
              </small>
            </span>
          </li>
        </ul>
      </div>
      <div class="list" v-if="gasMeter" :style="{'--grid-area': hasElec ? 'gas' : 'auto'}">
        <h3 class="list__title">
          <img class="list__title__icon" src="@/assets/icons/icon-gas.svg"/> 
          <span class="list__title__value">{{ $t("Offer.summary.gas") }}</span>                
        </h3>
        <ul class="list__items">
          <li class="list__items__item list__items__item--group-title">
            <span class="list__items__item__label ">{{ $t("Offer.summary.consumption") }}</span>
            <span class="list__items__item__value">{{ gasMeter.value }} kWh</span>
          </li>
        </ul>
      </div>
      <div class="list" :style="{'--grid-area': (hasElec && gasMeter) ? 'data' : 'auto'}">
        <h3 class="list__title">
          <img class="list__title__icon" src="@/assets/icons/icon-situation.svg"/> 
          <span class="list__title__value">{{ $t("Offer.summary.personelData") }}</span>                
        </h3>
        <ul class="list__items">
          <li class="list__items__item list__items__item--group-title">
            <span class="list__items__item__label ">{{ $t("Offer.summary.imAClient") }}</span>
            <span class="list__items__item__value">
              {{ $t(`step4.segment.${ !isPro ? 'b2c' : 'b2b'}`) }}
            </span>
          </li>
            <li class="list__items__item list__items__item--group-title">
            <span class="list__items__item__label ">{{ $t("Offer.summary.locality") }}</span>
            <span class="list__items__item__value">{{ zipCode }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="disclaimer" :class="$mq" v-html="simulation ? $t('Offer.disclaimerSimulation', [today.date]) : $t('Offer.disclaimerComparaison', [today.date])"></div>
    <div class="disclaimer" v-if="hasDiscount || hasMegaDiscount" :class="$mq" v-html="$t('Offer.disclaimerDiscount',
    {type : simulation ? $t('informations.simulation') : $t('informations.comparison')}
    )"></div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      showCondition: false
    };
  },
  computed: {
    ...mapGetters("energy", ["hasElec", "hasGas"]),
    ...mapGetters("consumption", ["monoMeter", "gasMeter", "nightMeter", "injectionBaseMeter", "touMeter", "injectionTouMeter", "activeConsumptions", "elecMeterTypes"]),
	...mapGetters("common", ["isTestAchat"]),
	...mapGetters("simulation", ["hasDiscount"]),
	...mapGetters("comparison", ["hasMegaDiscount"]),
    ...mapState("consumption", ["meterType", "solarPanelsScenario", "hasSmartMeter", "hasQuarterRegime", "knowPeakLevel", "peakLevel", "hasSolarPanels", "solarPanelsPower"]),
    ...mapState("calculation", ["zipCode", "city", "simulation"]),
    ...mapState("comparison", ["megaElecProduct", "megaGasProduct"]),
    ...mapState("contact", [
      "consent",
      "firstName",
      "lastName",
      "phone",
      "mail",
      "isPro"
    ]),
    today() {
      return {
        date: moment().format('DD/MM/YYYY').toString(),
        month: moment().format('MMM YYYY').toString()
      };
    },
    roundedPeakLevel() {
      return Math.round((parseFloat(this.peakLevel) + Number.EPSILON) * 100) / 100;
    },
    // hasDiscount() {
    //   return true;
    // },
  },
  methods: {
    isDual: function (meters) {
      return meters.filter(function (meter){
        return !meter.includes('injection');
      }).length;
    },
    getMeterTypeLabel(meterType) {
      return this.$t(`Offer.summary.meter.` + meterType);
    }
  },
};
</script>

<style lang="scss" scoped>
.summary-wrapper {
  margin-top: 15px;
  width: 100%;
  overflow: hidden;
  padding-bottom: 10px;

  h1 {
    margin: 0;
    margin-bottom: 10px;
    font-size: 1rem;
  }

  .summary {
    background: $clearYellow;
    padding: 15px;
    margin: 20px 0;
    border-radius: 15px;
    font-size: 0.8rem;
    // box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.3);
    display: grid;
    gap: 2rem;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: "elec gas" 
                         "elec data";

    &.mobile {
      grid-template-columns: 1fr;
      grid-template-areas:
      "elec" 
      "gas " 
      "data";
    }

    h2, h3 {
      margin: 0;
      font-size: 0.8rem;
      padding: 5px;
      padding-bottom: 10px;
    }

    > div {
      flex: 1;
    }

    .smart-meter {
      margin-top: 5px;
    }

    &.desktop {
      margin: 20px auto;
      width: 700px;
    }

    .list {
      grid-area: var(--grid-area);

      &__title {          
          text-align: left;
          padding: 0;
          display: flex;
          align-items: center;

        &__icon {
          height: 1.6rem;          
          margin-right: 0.3rem;
          min-width: 1.2rem;
        }

        &__value {
          border-bottom: 1px solid #000;
          width: 100%;
          padding-bottom: 2px;
        }
      }

      &__items {
        list-style-type: none;
        margin: 0;
        padding: 0;
        margin-left: 1.2rem;

        &__item {
          display: flex;
          justify-content: space-between;
          text-align: left;
          padding-left: 1.2rem;

          &__value {
            font-weight: 500;
          }

          &--group-title {
            padding-left: unset;
            margin-top: 0.3rem;
          }
        }
      }
    }
  }

  &.TA {
    .summary {
      border-radius: 0;
      background: $white;
      box-shadow: 0 0 7px rgba(0, 0, 0, 0.3);
    }
  }
}

.help {
  position: fixed;
  top: 350px;
  right: 0;
}

.disclaimer {
  text-align: justify;
  font-size: 0.7rem;
  margin: auto 0px!important;

  &.desktop {
    margin: 20px auto!important;
    width: 700px;
  }
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Informations.vue